import Vue from 'vue'
import Router from 'vue-router'

import Home from '../views/indexPage.vue'
import Detail from '../views/detailPage.vue'
import { i18n } from '@/i18n'; // 引入全局i18n实例

Vue.use(Router)

const routes = [
  {
    path: '/:lang',
    name: 'home',
    component: Home,
    // meta: { keepAlive: true },
    beforeEnter(to, from, next) {
      const lang = to.params.lang;
      // console.log('lang', lang);
      if (['kr', 'tw', 'jp'].includes(lang)) {
        i18n.locale = lang; // 更改全局i18n实例的locale属性
        document.querySelector('html').setAttribute('lang', lang); // 设置HTML lang属性
        next();
      } else {
        // 如果不合法的语言参数，则重定向到默认语言
        // next({ path: `/${lang}` });
        next({ path: '/tw' });
      }
    },
  },
  {
    path: '/:lang/detail',
    name: 'detail',
    component: Detail
  }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
